// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: ang inline flatpickr calendar — initFlatpickr,
// a11y wiring, ang inline host + open/close toggle, at ang
// syncSelectorDisplays helper (siya ang nagpapanatili ng "See full
// calendar"/"Hide calendar" label na pag-aari rin ng toggle na ito).
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const CONFIG = DP.CONFIG;
  const state = DP.state;

  // Three-way state of the #open-full-calendar toggle:
  //   • calendar open              → "Hide calendar"
  //   • selected date OUT of strip → a chip showing the full date (tap = reopen)
  //   • otherwise                  → "See full calendar →"
  // The chip is the ONLY place an advance-order date (beyond the 7-day strip)
  // stays visible once the calendar collapses — the strip can't render a pill
  // for a date it doesn't contain, so without this the pick looks lost.
  function renderCalendarToggle() {
    const { calendarBtn, dateDisplay, dateInput } = state.elements;
    if (!dateDisplay) return;

    if (state.calendarOpen) {
      if (calendarBtn) calendarBtn.classList.remove("full-calendar-link--chip");
      dateDisplay.textContent = "Hide calendar";
      if (calendarBtn) calendarBtn.setAttribute("aria-label", "Hide the full calendar");
      return;
    }

    const selectedDate = dateInput ? dateInput.value : "";
    const stripDays =
      typeof DP.getDateStripDays === "function" ? DP.getDateStripDays() : [];
    const outOfStrip = selectedDate && stripDays.indexOf(selectedDate) === -1;

    if (outOfStrip) {
      const d = dayjs.tz(selectedDate, "YYYY-MM-DD", CONFIG.timezone);
      if (calendarBtn) calendarBtn.classList.add("full-calendar-link--chip");
      dateDisplay.textContent = d.isValid() ? d.format("ddd, D MMM YYYY") : selectedDate;
      if (calendarBtn) {
        const full = d.isValid() ? d.format("dddd, MMMM D, YYYY") : selectedDate;
        calendarBtn.setAttribute("aria-label", "Delivery date " + full + ". Change date.");
      }
      return;
    }

    if (calendarBtn) calendarBtn.classList.remove("full-calendar-link--chip");
    dateDisplay.textContent = "See full calendar →";
    if (calendarBtn) {
      calendarBtn.setAttribute("aria-label", "Choose a date from the full calendar");
    }
  }

  function syncSelectorDisplays() {
    renderCalendarToggle();

    // Refresh the checkout button's dynamic date/time/subtotal meta line.
    // P8 2026-08-10: event contract na ('cart:meta-update') — ang listener ay
    // ang FlowercartCartFooter module sa sections/main-cart-footer.liquid.
    document.dispatchEvent(new CustomEvent("cart:meta-update"));
  }

  function initCalendarA11y(calendar, trigger) {
    if (!calendar) return;

    const calId = "delivery-date-calendar";
    calendar.setAttribute("id", calId);
    calendar.setAttribute("role", "dialog");
    calendar.setAttribute("aria-modal", "true");
    calendar.setAttribute("aria-label", "Select delivery date");

    if (trigger) {
      trigger.setAttribute("aria-haspopup", "dialog");
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("aria-controls", calId);
    }

    const weekdayRow = calendar.querySelector(".flatpickr-weekdaycontainer");
    if (weekdayRow) {
      weekdayRow.setAttribute("role", "row");
      weekdayRow.querySelectorAll(".flatpickr-weekday").forEach((el) => {
        el.setAttribute("role", "columnheader");
        el.setAttribute("scope", "col");
      });
    }

    const dayContainer = calendar.querySelector(".dayContainer");
    if (dayContainer) {
      dayContainer.setAttribute("role", "grid");
      dayContainer.setAttribute("aria-label", "Calendar days");
    }

    // Flatpickr renders its month <select> and year <input> without
    // accessible names. Additive labels only — no picker DOM is renamed.
    const monthSelect = calendar.querySelector(".flatpickr-monthDropdown-months");
    if (monthSelect) monthSelect.setAttribute("aria-label", "Month");
    const yearInput = calendar.querySelector(".numInput.cur-year");
    if (yearInput) yearInput.setAttribute("aria-label", "Year");
  }

  function getInlineCalendarHost(calendarBtn) {
    // Inline calendar lives between the "See full calendar" button and the
    // TIME SLOT divider, so it pushes content down instead of floating over it.
    let host = document.getElementById("delivery-calendar-inline");
    if (!host && calendarBtn && calendarBtn.parentNode) {
      host = document.createElement("div");
      host.id = "delivery-calendar-inline";
      host.className = "delivery-calendar-inline";
      // place it right after the button, still inside .date-strip-wrap
      calendarBtn.parentNode.insertBefore(host, calendarBtn.nextSibling);
    }
    return host;
  }

  // Hakbang 3 (2026-09-02): lahat ng dates sa window na dateBlocked:true —
  // walang lokal na date math, tumitingin lang sa server-provided window.
  function getDisabledDatesInWindow() {
    const availability = state.availability;
    if (!availability || !availability.dates) return [];

    return Object.keys(availability.dates).filter(
      (dateStr) => availability.dates[dateStr].dateBlocked
    );
  }

  function initFlatpickr() {
    const { dateInput, calendarBtn } = state.elements;
    if (!dateInput) return;

    const now = DP.getNowPH();
    const minDate = DP.getMinSelectableDate(now);
    const maxDate = DP.getMaxSelectableDate(minDate);

    if (state.fpInstance) state.fpInstance.destroy();

    const inlineHost = getInlineCalendarHost(calendarBtn);

    state.fpInstance = flatpickr(dateInput, {
      minDate,
      maxDate,
      disable: getDisabledDatesInWindow(),
      dateFormat: "Y-m-d",
      disableMobile: true,
      inline: true,
      appendTo: inlineHost || undefined,
      positionElement: calendarBtn,

      onReady: (_dates, _str, fp) => {
        initCalendarA11y(fp.calendarContainer, calendarBtn);
      },

      onOpen: (_dates, _str, fp) => {
        if (calendarBtn) calendarBtn.setAttribute("aria-expanded", "true");

        state.calendarEscapeHandler = (e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            fp.close();
          }
        };
        fp.calendarContainer.addEventListener("keydown", state.calendarEscapeHandler);

        window.requestAnimationFrame(() => {
          const sel = fp.calendarContainer.querySelector(".flatpickr-day.selected");
          const first = fp.calendarContainer.querySelector(
            ".flatpickr-day:not(.flatpickr-disabled):not(.notAllowed):not(.prevMonthDay):not(.nextMonthDay)"
          );
          const target = sel || first;
          if (target) target.focus();
        });
      },

      onClose: (_dates, _str, fp) => {
        if (calendarBtn) {
          calendarBtn.setAttribute("aria-expanded", "false");
          window.requestAnimationFrame(() => calendarBtn.focus());
        }

        if (state.calendarEscapeHandler) {
          fp.calendarContainer.removeEventListener("keydown", state.calendarEscapeHandler);
          state.calendarEscapeHandler = null;
        }
      },

      onDayCreate: (_dates, _str, fp, dayElem) => {
        const isPrevNext =
          dayElem.classList.contains("prevMonthDay") ||
          dayElem.classList.contains("nextMonthDay");

        if (isPrevNext) {
          dayElem.setAttribute("aria-hidden", "true");
          dayElem.setAttribute("tabindex", "-1");
          return;
        }

        const isDisabled =
          dayElem.classList.contains("flatpickr-disabled") ||
          dayElem.classList.contains("notAllowed");

        if (dayElem.dateObj instanceof Date && !isNaN(dayElem.dateObj)) {
          const cellDateStr = dayjs(dayElem.dateObj).format("YYYY-MM-DD");
          const label = DP.buildAriaLabelForDay(cellDateStr);
          if (label) dayElem.setAttribute("aria-label", label);
        }

        dayElem.setAttribute("role", "gridcell");

        if (isDisabled) {
          dayElem.setAttribute("aria-disabled", "true");
          dayElem.setAttribute("tabindex", "-1");
        } else if (dayElem.classList.contains("selected")) {
          dayElem.setAttribute("aria-disabled", "false");
          dayElem.setAttribute("aria-selected", "true");
          dayElem.setAttribute("aria-current", "date");
          dayElem.setAttribute("tabindex", "0");
        } else {
          dayElem.setAttribute("aria-disabled", "false");
          dayElem.setAttribute("aria-selected", "false");
          dayElem.setAttribute("tabindex", "-1");
        }
      },

      onChange: (_selectedDates, dateStr) => {
        DP.renderDateStrip();
        DP.renderTimeSlots(dateStr);
        DP.renderCountdown();
        // Collapse the inline calendar back to the date strip after a pick.
        toggleInlineCalendar(false);
        syncSelectorDisplays();
        void DP.updateCart(DP.buildCartPayload(), "calendar");

        window.requestAnimationFrame(() => {
          if (state.fpInstance) {
            state.fpInstance.calendarContainer
              .querySelectorAll(".flatpickr-day")
              .forEach((d) => {
                if (d.classList.contains("selected")) {
                  d.setAttribute("aria-selected", "true");
                  d.setAttribute("aria-current", "date");
                  d.setAttribute("tabindex", "0");
                } else if (
                  !d.classList.contains("prevMonthDay") &&
                  !d.classList.contains("nextMonthDay")
                ) {
                  d.setAttribute("aria-selected", "false");
                  d.removeAttribute("aria-current");
                }
              });
          }
        });
      }
    });

    if (calendarBtn && !calendarBtn.dataset.deliveryCalendarBound) {
      calendarBtn.addEventListener("click", () => toggleInlineCalendar());
      calendarBtn.dataset.deliveryCalendarBound = "true";
    }
  }

  function toggleInlineCalendar(forceOpen) {
    const { calendarBtn } = state.elements;
    const host = document.getElementById("delivery-calendar-inline");
    if (!host || !calendarBtn) return;

    const willOpen =
      typeof forceOpen === "boolean" ? forceOpen : !host.classList.contains("is-open");

    host.classList.toggle("is-open", willOpen);
    state.calendarOpen = willOpen;
    calendarBtn.setAttribute("aria-expanded", willOpen ? "true" : "false");
    renderCalendarToggle();

    if (willOpen) {
      window.requestAnimationFrame(() => {
        const cont = host.querySelector(".flatpickr-calendar");
        if (!cont) return;
        const sel = cont.querySelector(".flatpickr-day.selected");
        const first = cont.querySelector(
          ".flatpickr-day:not(.flatpickr-disabled):not(.notAllowed):not(.prevMonthDay):not(.nextMonthDay)"
        );
        (sel || first)?.focus();
      });
    }
  }

  DP.syncSelectorDisplays = syncSelectorDisplays;
  DP.initFlatpickr = initFlatpickr;
})();
